// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__3YQ36","desktopImage":"styles_desktopImage__19vTR"};